import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'roblex-collapsed-sidepanel-overlay',
  templateUrl: './collapsed-sidepanel-overlay.component.html',
  styleUrls: ['./collapsed-sidepanel-overlay.component.scss']
})
export class CollapsedSidepanelOverlayComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
